module.exports = __webpack_public_path__ + "assets/99d7aa14f9ef7cfe56da934b81e04479.png";